// forumBuilderSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  forumlist: [],
  associatedDocuments: [],
  associatedVideos: [],
  associatedLinks: [],
  forumModal: false,
};

const forumBuilder = createSlice({
  name: "forumBuilder",
  initialState,
  reducers: {
    setForumList: (state, action) => {
      state.forumlist = action.payload;
    },

    // Add a generic reducer for all content types
    setAssociatedContent: (state, action) => {
      const { contentType, data } = action.payload;
      switch (contentType) {
        case "document":
          state.associatedDocuments = data;
          break;
        case "video":
          state.associatedVideos = data;
          break;
        case "link":
          state.associatedLinks = data;
          break;
        default:
          break;
      }
    },
    // Add a reducer to add single item

    // Add a reducer to remove single item
    removeAssociatedContent: (state, action) => {
      const { contentType, id } = action.payload;

      switch (contentType) {
        case "document":
          state.associatedDocuments = state.associatedDocuments.filter(
            (doc) => doc.contentId !== id
          );
          break;
        case "video":
          state.associatedVideos = state.associatedVideos.filter(
            (video) => video.contentId !== id
          );
          break;
        case "link":
          state.associatedLinks = state.associatedLinks.filter(
            (link) => link.contentId !== id
          );
          break;
        default:
          break;
      }
    },
    resetAssociatedContent: (state) => {
      state.associatedDocuments = [];
      state.associatedVideos = [];
      state.associatedLinks = [];
    },
  },
});

export const {
  setForumList,
  setAssociatedContent,
  removeAssociatedContent,
  resetAssociatedContent,
} = forumBuilder.actions;

export default forumBuilder.reducer;
